'use client';

import { c as _c } from "react/compiler-runtime";
import * as SliderPrimitive from '@radix-ui/react-slider';
import * as React from 'react';
import { cn } from '@/frontend/utils';
import { sliderStyles } from './sliderStyles';
type SliderProps = ({
  variant?: 'single' | 'double';
  color?: never;
} | {
  variant: 'none';
  color?: keyof typeof sliderStyles;
}) & {
  className?: string;
} & React.ComponentPropsWithoutRef<typeof SliderPrimitive.Root>;
const Slider = React.forwardRef<React.ElementRef<typeof SliderPrimitive.Root>, SliderProps>(function Slider(t0, ref) {
  const $ = _c(29);
  let className;
  let color;
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      variant: t1,
      color,
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = color;
    $[3] = props;
    $[4] = t1;
  } else {
    className = $[1];
    color = $[2];
    props = $[3];
    t1 = $[4];
  }
  const variant = t1 === undefined ? "single" : t1;
  const effectiveColor = variant === "single" || variant === "double" ? "algoprimary" : color ?? "algoprimary";
  let t2;
  if ($[5] !== className) {
    t2 = cn("relative flex w-full touch-none select-none items-center", className);
    $[5] = className;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const t3 = sliderStyles[effectiveColor];
  let t4;
  if ($[7] !== t3.track) {
    t4 = cn("relative h-2 w-full grow overflow-hidden rounded-full", t3.track);
    $[7] = t3.track;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const t5 = sliderStyles[effectiveColor];
  let t6;
  if ($[9] !== t5.range) {
    t6 = cn("absolute h-full rounded-full", t5.range);
    $[9] = t5.range;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t6) {
    t7 = <SliderPrimitive.Range className={t6} />;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== t4 || $[14] !== t7) {
    t8 = <SliderPrimitive.Track className={t4}>{t7}</SliderPrimitive.Track>;
    $[13] = t4;
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== effectiveColor || $[17] !== variant) {
    t9 = variant !== "none" && <SliderPrimitive.Thumb className={cn("block h-4 w-4 rounded-full border-2 shadow transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-backgroundInverseTertiary focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50", sliderStyles[effectiveColor].thumb)} />;
    $[16] = effectiveColor;
    $[17] = variant;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== effectiveColor || $[20] !== variant) {
    t10 = variant === "double" && <SliderPrimitive.Thumb className={cn("block h-4 w-4 rounded-full border-2 shadow transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-backgroundInverseTertiary focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50", sliderStyles[effectiveColor].thumb)} />;
    $[19] = effectiveColor;
    $[20] = variant;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== props || $[23] !== ref || $[24] !== t10 || $[25] !== t2 || $[26] !== t8 || $[27] !== t9) {
    t11 = <SliderPrimitive.Root ref={ref} className={t2} {...props}>{t8}{t9}{t10}</SliderPrimitive.Root>;
    $[22] = props;
    $[23] = ref;
    $[24] = t10;
    $[25] = t2;
    $[26] = t8;
    $[27] = t9;
    $[28] = t11;
  } else {
    t11 = $[28];
  }
  return t11;
});
Slider.displayName = SliderPrimitive.Root.displayName;
export { Slider };